import {faChevronsRight} from "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    ButtonSubmit,
    ColourSolid,
    FlexGap,
    StackVertical,
    ToggleSwitch,
    ToggleType
} from "@twigsby/frontend-framework";
import {useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useState} from "react";
import {RulesetAction} from "./Components/Action/RulesetAction";
import {RulesetFilters} from "./Components/Filter/RulesetFilters";
import {RulesetName} from "./Components/RulesetName";
import {RulesetScanType} from "./Components/Type/RulesetScanType";

const CreateRuleset = () => {
    const { getValues, setValue} = useFormContext();
    const [ activeFilters, setActiveFilters ] = useState<Array<number>>([]);

    const itemCount = Math.floor(Math.random() * 10);

    return (
        <div className={'card thing thing-vertical'}>
            <div className={'thing-wrapper'}>
                <div className={'thing-container thing-container-start'}>
                    <h6 className={'thing-title sub-heading pageantry-sub-heading text-left '}>Ruleset Name</h6>
                    <RulesetName name={'name'} />
                </div>

                <div className={'thing-separator'}>
                    <div className={'thing-separator-icon'}>
                        <FontAwesomeIcon icon={faChevronsRight} fixedWidth={true} />
                    </div>
                </div>

                <div className={'thing-container'}>
                    <h6 className={'thing-title sub-heading pageantry-sub-heading text-left '}>If Criteria Matches</h6>
                    <RulesetScanType name={'scanType'} />
                    <RulesetFilters
                        name={'filters'}
                        activeFilters={activeFilters}
                        filterChangedCallback={(val: Array<number>) => setActiveFilters(val)}
                    />
                </div>

                <div className={'thing-separator'}>
                    <div className={'thing-separator-icon'}>
                        <FontAwesomeIcon icon={faChevronsRight} fixedWidth={true} />
                    </div>
                </div>

                <div className={'thing-container thing-container-end'}>
                    <h6 className={'thing-title sub-heading pageantry-sub-heading text-left '}>Then Do This</h6>
                    <RulesetAction name={'action'} />
                </div>

                <div className={'thing-separator'}>
                    <div className={'thing-separator-icon'}>
                        <FontAwesomeIcon icon={faChevronsRight} fixedWidth={true} />
                    </div>
                </div>

                    <div className={'thing-container thing-container-end'}>
                        {itemCount > 0 && (
                            <h6 className={'thing-title sub-heading pageantry-sub-heading text-left '}>Finalise</h6>
                        )}

                        <StackVertical gap={FlexGap.Medium}>

                            {itemCount > 0 && (
                                <ToggleSwitch
                                    name={'ApplyExisting'}
                                    label={`Apply to ${itemCount} matching ${itemCount === 1 ? 'item' : 'items'}?`}
                                    type={ToggleType.Checkbox}
                                    defaultChecked={getValues(`applyToExisting`)}
                                    onChange={(e) => setValue(`applyToExisting`, e.currentTarget.checked)}
                                />
                            )}

                            <ButtonSubmit
                                fullWidth={true}
                                title={'Save Ruleset'}
                                colour={ColourSolid.Primary}
                                extraClass={'ml-a'}
                            />
                        </StackVertical>

                    </div>

            </div>

        </div>

    )
}

export { CreateRuleset }
